import { Revision } from "../../models-v2/Revision";
import AxiosService from "../../services/axios-service/AxiosService";
import ErrorHandler from "../../utils/ErrorHandler";
import Storage from "../storage/Storage";

const MANAGER_API_URL = process.env.REACT_APP_MANAGER_API + "/revisions";

export class RevisionService {
    static async getRevisions(eitriAppId: string): Promise<Revision[]> {
        let token, config;
        const ORDER = "DESC", SORT = "version"
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (error) {
            ErrorHandler.handleError(error);
        }

        config = {
            headers: {
                Authorization: "Bearer " + token
            },
            params: { eitriAppId, order: ORDER, sort: SORT }
        };

        const url = MANAGER_API_URL;
        const resp = await AxiosService.httpGet(url, config);
        return resp.data;
    }

    static async publishingRevision(
        revisionId: string,
        envId: string
    ): Promise<void> {
        let token, config;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (error) {
            ErrorHandler.handleError(error);
        }

        config = {
            headers: {
                Authorization: "Bearer " + token
            }
        };

        const body = {
            envId
        };

        const url = MANAGER_API_URL + `/${revisionId}/publish`;
        return await AxiosService.httpPut(url, body, config);
    }
}
